<template>
  <v-card
    id="ot"
    fluid
  >
  <v-card-title class="blue darken-3">
          <span class="text-h5 white--text">{{title}}</span>

  </v-card-title>
  
<v-banner></v-banner>

  <v-row align="baseline">
    <v-col cols="12" md="3">
      <v-text-field
        v-model="nuit_txt"
        label="nuit"
      ></v-text-field>
    </v-col>
    <v-col cols="12" md="3">
      <v-btn
                color="blue darken-1"
                text
                @click="Envoyer_la_nuit"
              >
              Go
              </v-btn>

    </v-col>
  </v-row>





</v-card>
</template>
<script>
//import { strictEqual } from 'assert';

  
  export default {
    data: () =>({


      nuit_txt: "",

      title: "Manolo",

      A_Update_tel : null,
      A_Update_targets : null,




    }),
    initialize(){

    },
  created(){
    
  },
  beforeMount(){
     

  },
  mounted(){


  },

  methods: {


    Envoyer_la_nuit(){

      const othis = this;
      //console.log(JSON.parse(this.nuit_txt));
      var json_nuit = JSON.parse(this.nuit_txt);
      console.log(json_nuit);

      this.axios.post( "http://wwwtbl.pic.obs-mip.fr:8080/Ph3/Nuit/set",json_nuit)
     .then((res) => {
      console.log(ok);
        console.log(res);
 
     })
     .catch((err) => {
        console.log("err");
         console.log(err);
 
     });



    },
    get_Targets(){

        const othis = this;
        

        this.axios.get( backend_url + "/Pilote/Targets")
        .then((res) => {

            othis.tel.targets = JSON.parse(JSON.stringify(res.data));
            
        })
        .catch(() => {
          console.log("PB with load Targets");
        });
    
    },
    load_Targets(){
      var t_targets = [];
      for(var target of this.tel.targets){
        t_targets.push(target);
      };  
      this.targets = JSON.parse(JSON.stringify(t_targets));
    },

    get_PosTel(){ //{"timestamp":"2022-09-03T20:43:02.000Z","st":"21h37m35s","ah":"+02h59m54s","ra":279.425,"dec":38.8035,"airmass":1.204,"telmarche":3}
      var othis = this;
    //Object.assign(this.editedItem,this.defaultItem);
      this.axios.get(backend_url + "/Pilote/lastpos")
      .then((res) => {
          othis.tel.lastpos = JSON.parse(JSON.stringify(res.data));
          othis.tel.lastpos.date = othis.tel.lastpos.timestamp.split("T")[0];
          const tab = othis.tel.lastpos.timestamp.split("T")[1].split(":");
          othis.tel.lastpos.time = tab[0] + ":" + tab[1];
          othis.lastpos = othis.tel.lastpos;
          
          
      })
      .catch(() => {
        console.log("PB with load POs Tel ha oui?");
      });


    },
    load_PosTel(){
        this.lastpos = this.tel.lastpos;
    }
  }
}
</script>